import { ReactComponent as ToggleListIcon } from 'assets/icons/listToggle24.svg'
import cx from 'classnames'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useToggleBlockToggle } from 'common/Prose/Toolbar/hooks/useToggleBlockToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { observer } from 'mobx-react-lite'
import Styles from '../MobileToolbar.module.scss'

export const ToggleBlockButton = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useToggleBlockToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Turn into toggle block"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
        [Styles.disabled]: disabled,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-toggle-block-mark"
      {...props}
    >
      <ToggleListIcon />
    </Button>
  )
})
